import { render, staticRenderFns } from "./bigDataTemplate.vue?vue&type=template&id=437cfd32&scoped=true"
import script from "./bigDataTemplate.vue?vue&type=script&lang=js"
export * from "./bigDataTemplate.vue?vue&type=script&lang=js"
import style0 from "./bigDataTemplate.vue?vue&type=style&index=0&id=437cfd32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437cfd32",
  null
  
)

export default component.exports